/* src/app/components/admin/server-config/server-config/server-config.component.scss */
:host(lex-server-config) mat-form-field {
  --line-ripple-before: white;
}
:host(lex-server-config) lex-server-config-item {
  display: flex;
  flex-grow: 1;
}
mat-form-field.custom-form-field-placeholder-colors {
  --light-theme-color: rgb(255 255 255 / 60%);
  --dark-theme-color: rgb(255 255 255 / 60%);
}
.container {
  height: 100%;
  display: flex;
  flex-direction: column;
  place-content: stretch center;
  align-items: stretch;
  flex: 1 1 100%;
  max-width: 68%;
  margin: auto;
}
.container > mat-toolbar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.mat-mdc-card.scrollable-content {
  display: flex;
  overflow: hidden;
  flex-direction: column;
  flex: 1 1;
}
.mat-mdc-card.scrollable-content > .mat-mdc-card-content {
  overflow-y: auto;
  flex: 1 1;
}
.mat-mdc-card.scrollable-content > .mat-mdc-card-actions {
  display: flex;
  justify-content: flex-end;
  gap: 4px;
}
.search-control {
  display: flex;
  justify-content: flex-end;
}
.search-control > mat-form-field {
  font-size: 12px;
}
.column-border {
  flex: 1 1 100%;
  box-sizing: border-box;
  max-height: 10%;
}
/*# sourceMappingURL=server-config.component.css.map */
